import { defineLocaleOverrides } from '@link/share/i18n';

/**
 * Wording this app overrides on top of share's text. Japanese only — every
 * other locale keeps share's wording for these fields.
 */
export default defineLocaleOverrides({
  ja: {
    requireForm: {
      bookingFields: {
        passportFirstName: '参加者名（ローマ字名）',
        passportLastName: '参加者姓（ローマ字姓）'
      }
    }
  }
});
